import { render, staticRenderFns } from "./ObraSynopsisCard.vue?vue&type=template&id=128f78ac"
import script from "./ObraSynopsisCard.vue?vue&type=script&lang=js"
export * from "./ObraSynopsisCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports